import React from 'react';

import ProgramTooltipDetails from 'app/shared/components/common/ProgramTooltipDetails';
import _ from 'lodash';

import { FeeCalculationType } from 'constants/feeTypes';
import { getGroupsMapsByLLPACaps, getLLPACapsPreparedList } from 'utils/llpaCaps';
import { formatNumberToFixed3Decimals } from 'utils/number';

const renderProgramTooltipDetails = (data, format) => (
  <ProgramTooltipDetails data={data} format={format} />
);

export const getProgramsWithPreparedLLPACaps = (llpaTypesValues, loanPrograms) =>
  loanPrograms.map(item => {
    const preparedLlpaCaps = Object.values(
      item.caps.reduce((acc, cap) => {
        if (cap.hasAllLlpaTypes) {
          llpaTypesValues.forEach(({ llpaTypeId }) => {
            if (!acc[llpaTypeId]) {
              acc[llpaTypeId] = {
                llpaTypeId,
                amount: cap.amount,
                wasApplied: cap.wasApplied,
                criteriaId: cap.criteriaId,
              };
            }
          });
        }

        if (!cap.hasAllLlpaTypes) {
          acc[cap.llpaTypeId] = cap;
        }

        return acc;
      }, {}),
    );

    const llpaGroups = getGroupsMapsByLLPACaps(preparedLlpaCaps);
    const llpaCapsPreparedList = getLLPACapsPreparedList({
      llpaTypes: llpaTypesValues,
      llpaCaps: preparedLlpaCaps,
      llpaCapsGroupsMap: llpaGroups,
    });

    return {
      ...item,
      adjustments: item.adjustments.map(adjustment => ({
        ...adjustment,
        groupId: llpaGroups[adjustment.llpaTypeId] ?? 0,
      })),
      llpaCapsPreparedList,
      llpaGroups,
      totalAfterCap: item.totalAdjustmentAfterCap,
    };
  });

const adjustmentDetailsFormat = {
  valueFormat: formatNumberToFixed3Decimals,
};

const getTotalAdjustmentOption = data => ({
  name: 'Total Adjustments',
  value: _.sumBy(data, 'value'),
  isNewGroup: true,
});

export const getProgramNameTooltip = ({
  adjustments,
  customAdjustments,
  llpaCapsPreparedList,
  totalAfterCap,
  classes,
}) => {
  const normalizedAdjustments = (adjustments || []).map(
    ({ adjustmentName, adjustment, calculationType, groupId }) => {
      const isDeleted = !!customAdjustments.find(
        ({ name }) => name === adjustmentName && calculationType === FeeCalculationType.CUSTOM,
      )?.isDeleted;

      return {
        name: isDeleted ? `${adjustmentName} (Deleted)` : adjustmentName,
        value: adjustment,
        meta: isDeleted ? { rowClassName: 'text-orange' } : null,
        groupId,
      };
    },
  );
  const normalizedData = [
    ...normalizedAdjustments,
    getTotalAdjustmentOption(normalizedAdjustments),
    ...(llpaCapsPreparedList || []).map(({ amount, name, groupId }) => ({
      name,
      value: amount,
      groupId,
    })),
    {
      name: 'Total after cap',
      value: totalAfterCap,
      isNewGroup: true,
      meta: { rowClassName: classes?.tooltipTotalAfterCap },
    },
  ];

  return renderProgramTooltipDetails(normalizedData, adjustmentDetailsFormat);
};
